export default "__VITE_ASSET__wj1h5tEH__"